import { useApiQuery } from '@BUP/hooks/useApiQuery'

/**
 * Different grades can each have their own period open at the same time (a period scopes exactly
 * one grade), so "current" is ambiguous without a grade - pass the one the counselor is currently
 * looking at. The query stays disabled until a grade is picked.
 */
export const useGetCurrentPeriodStatus = (grade) => {
  const query = useApiQuery(
    ['courseAssignmentPeriodStatus', grade],
    'schools',
    client => client.get('/current-organization/course-assignment/periods/current', { params: { grade } }),
    { enabled: !!grade },
    { authenticated: true, version: 5 }
  )

  return {
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    period: query.data?.period ?? null,
    error: query.error,
    refetch: query.refetch
  }
}
